import {
  HHBox,
  HHButton,
  HHStack,
  HHTypography,
} from '@hinge-health/react-component-library';
import React from 'react';

export const CURSOR_PAGINATION_PREVIOUS_TEST_ID =
  'partner-data-gateway-pagination-previous-button';
export const CURSOR_PAGINATION_NEXT_TEST_ID =
  'partner-data-gateway-pagination-next-button';
export const CURSOR_PAGINATION_PAGE_TEST_ID =
  'partner-data-gateway-pagination-page-label';

export interface CursorPaginationProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
  /**
   * When provided, renders a "Page N" indicator between the controls. Cursor
   * pagination has no total page count, so this is the 1-based index of the
   * page currently being viewed rather than "page N of M".
   */
  currentPage?: number;
}

/**
 * Forward/backward controls for cursor-based pagination. The module tracks
 * the cursor stack itself (see `hooks/use-ingestions.ts`) — this component
 * only renders the controls and reports intent.
 */
export const CursorPagination = ({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  currentPage,
}: CursorPaginationProps): JSX.Element => (
  <HHStack
    direction="row"
    gap={1}
    alignItems="center"
    justifyContent="flex-end"
  >
    <HHButton
      hhVariant="variant-bypass"
      variant="outlined"
      size="small"
      disabled={!hasPrevious}
      onClick={onPrevious}
      data-testid={CURSOR_PAGINATION_PREVIOUS_TEST_ID}
    >
      Previous
    </HHButton>
    {currentPage !== undefined && (
      <HHBox data-testid={CURSOR_PAGINATION_PAGE_TEST_ID}>
        <HHTypography hhVariant="variant-bypass" variant="body2">
          {`Page ${currentPage}`}
        </HHTypography>
      </HHBox>
    )}
    <HHButton
      hhVariant="variant-bypass"
      variant="outlined"
      size="small"
      disabled={!hasNext}
      onClick={onNext}
      data-testid={CURSOR_PAGINATION_NEXT_TEST_ID}
    >
      Next
    </HHButton>
  </HHStack>
);
